import React, { useRef } from 'react'
import { IconButton } from '../../../ui'

const SESSION_COLOR = '#9b6cc4'

export function DateHintList({ items = [], onChange, maxItems = 10, maxChars = 140, dateHintMaxChars = 20, readOnly = false }) {
  const textRefs = useRef([])

  function update(index, patch) {
    const next = items.map((item, i) => (i === index ? { ...item, ...patch } : item))
    onChange({ items: next })
  }

  function handleAdd() {
    if (items.length >= maxItems) return
    onChange({ items: [...items, { text: '', dateHint: '' }] })
    setTimeout(() => textRefs.current[items.length]?.focus(), 0)
  }

  function handleRemove(index) {
    onChange({ items: items.filter((_, i) => i !== index) })
  }

  function handleKeyDown(e, index) {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    } else if (e.key === 'Backspace' && items[index]?.text === '' && items.length > 0) {
      e.preventDefault()
      handleRemove(index)
      setTimeout(() => textRefs.current[Math.max(0, index - 1)]?.focus(), 0)
    }
  }

  return (
    <div style={styles.wrap}>
      {items.map((item, index) => (
        <div key={index} style={styles.row}>
          <span style={styles.prefix}>–</span>
          <input
            ref={(el) => { textRefs.current[index] = el }}
            style={styles.input}
            value={item.text}
            maxLength={maxChars}
            disabled={readOnly}
            placeholder={readOnly ? '' : 'Follow-up item…'}
            onChange={(e) => update(index, { text: e.target.value })}
            onKeyDown={(e) => handleKeyDown(e, index)}
            aria-label={`Follow-up ${index + 1}`}
          />
          <input
            style={styles.dateHint}
            value={item.dateHint}
            maxLength={dateHintMaxChars}
            disabled={readOnly}
            placeholder={readOnly ? '' : 'when?'}
            onChange={(e) => update(index, { dateHint: e.target.value })}
            aria-label={`Date hint for follow-up ${index + 1}`}
          />
          {!readOnly && (
            <IconButton ariaLabel="Remove item" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
          )}
        </div>
      ))}
      {!readOnly && items.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ add</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px', display: 'flex', flexDirection: 'column', gap: '4px' },
  row: { display: 'flex', alignItems: 'center', gap: '6px' },
  prefix: { fontSize: '12px', color: 'var(--text-secondary)', opacity: 0.5, minWidth: '10px', flexShrink: 0 },
  input: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', color: 'var(--text-primary)', lineHeight: '1.5', padding: '2px 0',
  },
  dateHint: {
    width: '72px', flexShrink: 0, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '10px', color: 'var(--text-secondary)', lineHeight: '1.5', padding: '2px 0',
    textAlign: 'right',
  },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: SESSION_COLOR, padding: '2px 0', marginLeft: '16px', marginTop: '2px', textAlign: 'left',
  },
}
